import { Heading } from "@/atoms/Typography"
import { motion } from "framer-motion"

import styled from 'styled-components'


export const DotContainer = styled(motion.div)`
  position: absolute;
  width: 20px;
  height: 20px;
  transform: translate(-50%, -50%);
  z-index: 10;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
  }
`

export const Dot = styled(motion.div)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #00305c;
  position: relative;
  z-index: 2;
`

export const PulseWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`

export const Pulse = styled(motion.div)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid #d8d8d8;
`

export const TooltipWrapper = styled.div`
  position: absolute;
  z-index: ${(props) => (props.$isActive ? 11 : 10)};
  pointer-events: none;

  ${(props) =>
    props.$isMobile &&
    `
    position: absolute;
    left: 0 !important;
    width: 100%;
    top: 20px;
  `}
`

export const TooltipContainer = styled(motion.div)`
  position: absolute;
  background: white;
  border-radius: ${({ theme }) => theme.rem(28)};
  border: 1px solid ${({ theme }) => theme.colors.secondary.light4};
  box-shadow: 0 3px 16px rgba(0, 0, 0, 0.2);
  width: 450px;
  overflow: hidden;
  pointer-events: auto;
  padding: ${({ $isActive }) => ($isActive ? '15px' : '0')};
  transition: padding 0.2s ease-in-out;

  ${(props) =>
    props.$isMobile &&
    `
    position: relative;
    width: 100%;
    max-width: none;
    left: auto;
    transform: none;
    top: 20px;
  `}

  ${(props) =>
    !props.$isMobile &&
    props.$position === 'left' &&
    `
    right: 30px;
    left: auto;
    top: -30px;
    transform: translateY(-50%);
  `}

  ${(props) =>
    !props.$isMobile &&
    props.$position === 'right' &&
    `
    left: 30px;
    right: auto;
    top: -30px;
    transform: translateY(-50%);
  `}
`

export const TooltipHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #dbeafe;
  cursor: pointer;
  gap: ${({ theme }) => theme.rem(8)};
  border-radius: ${({ $isActive, theme }) => ($isActive ? theme.rem(14) : '0')};
  transition: border-radius 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary.light4};
  }
`

export const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`

export const Title = styled(Heading)`
  color: ${({ theme }) => theme.colors.primary.default};
  text-align: left;
`

export const TooltipBody = styled(motion.div)`
  padding: ${({ theme }) => theme.rem(16)};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(16)};
  color: ${({ theme }) => theme.colors.primary.default};
`

export const TooltipBodyCtasContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(16)};
  justify-content: center;
`